export function EnexTagList({ allTags, counts, tags, setTags, untagged, setUntagged, untaggedCount }) {
  const toggle = (t) => setTags((s) => { const n = new Set(s); n.has(t) ? n.delete(t) : n.add(t); return n; });
  const allOn = allTags.every((t) => tags.has(t));
  const chip = "flex items-center gap-2 rounded-full border border-slate-200 px-3 py-1 text-sm cursor-pointer hover:bg-slate-50";
  return (
    <div>
      {allTags.length > 0 && (
        <button type="button" onClick={() => setTags(allOn ? new Set() : new Set(allTags))} data-testid="enex-tags-toggle-all"
                className="text-xs font-semibold text-rf-orange mb-2">{allOn ? "Untick all tags" : "Tick all tags"}</button>
      )}
      <div className="flex flex-wrap gap-2 max-h-56 overflow-y-auto" data-testid="enex-tag-list">
        {allTags.map((t) => (
          <label key={t} className={chip}>
            <input type="checkbox" className="w-4 h-4 accent-rf-orange" checked={tags.has(t)} onChange={() => toggle(t)} data-testid={`enex-tag-${t}`} />
            {t} <span className="text-slate-400">({counts[t]})</span>
          </label>
        ))}
        {untaggedCount > 0 && (
          <label className={chip}>
            <input type="checkbox" className="w-4 h-4 accent-rf-orange" checked={untagged} onChange={(e) => setUntagged(e.target.checked)} data-testid="enex-untagged" />
            <em>Notes without tags</em> <span className="text-slate-400">({untaggedCount})</span>
          </label>
        )}
        {!allTags.length && untaggedCount > 0 && <p className="text-sm text-slate-500" data-testid="enex-no-tags">No tags in these notes — every ticked notebook will come in whole.</p>}
      </div>
    </div>
  );
}
